const obj = {
  lessThan25k: 'lessThan25k',
  between25k50k: 'between25k50k',
  moreThan50k: 'moreThan50k',
}

export default obj
